const disablePageScroll = () => {
    document.body.classList.add("disable-page-scroll");
};

const enablePageScroll = () => {
    document.body.classList.remove("disable-page-scroll");
};

const getPageScrollY = () => window.scrollY;

export function usePageScrollService() {
    return {
        disablePageScroll,
        enablePageScroll,
        getPageScrollY,
    };
}
